<template>
  <div class="w-100">
    <div class="form-group mb-0" style="position:relative" v-if="this.label_input == false">
      <div class="input-group">
        <input style="border:none !important;" type="text" :class="classInput != undefined ? classInput : 'form-control input-for'" :placeholder="placeholder" v-on:keyup="checkForResults" v-model="localSearch" autocomplete="off">
        <!-- <div class="input-group-append">
          <div class="input-group-text bg-transparent">
            <i class="material-icons">search</i>
          </div>
        </div> -->
      </div>
      <ul class="list-group results shadow" v-if="localSearch">
        <a  
          class="list-group-item list-group-item-action" 
          @click="$emit('new', true)"
          v-if="newContact">
          <img src="@/assets/icons/plus.svg" width="10"> Crear nuevo
        </a>
        <a class="list-group-item list-group-item-action"  @click="setNewResult" v-if="$route.path.includes('/cotizaciones') && !newContact">
          Cerrar
        </a>
        <a class="list-group-item list-group-item-action" v-for="(result, index) in results" :key="index" @click="setResult(result)">
          <span v-if="field2 == undefined">{{ result[field] }} </span>
          <span v-else>{{ result[field] }} {{result[field2]}} </span>
        </a>
      </ul>
    </div>
    <div v-else class="w-100">
      <div class="form-group">
        <div class="input-field">
          <input id="search_term" class="main-input" type="text" placeholder="_" v-on:keyup="checkForResults" v-model="localSearch" autocomplete="off"/>
          <label class="main-label" for="search_term">{{this.placeholder}}</label>
        </div>
        <ul class="list-group results shadow" v-if="localSearch">
          <a  
            class="list-group-item list-group-item-action" 
            @click="$emit('new', true)"
            v-if="newContact">
            <img src="@/assets/icons/plus.svg" width="10"> Crear nuevo
          </a>
          <a class="list-group-item list-group-item-action"  @click="setNewResult" v-if="$route.path.includes('/cotizaciones') && !newContact">
            Cerrar
          </a>
          <a class="list-group-item list-group-item-action" v-for="(result, index) in results" :key="index" @click="setResult(result)">
            <span v-if="field2 == undefined">{{ result[field] }} </span>
            <span v-else>{{ result[field] }} {{result[field2]}} </span>
          </a>
        </ul>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  props: {
    newContact: {
      type: Boolean,
      required: false,
      default: false
    },
    array: {
      type: Array,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    field2:{
      type:String
    },
    placeholder: {
      type: String,
      required: false
    },
    classInput:{
      type: String
    },
    label_input:{
      type:Boolean,
      required:false
    }
  },
  computed: {
    results() {
      return this.array.filter(item => item[this.field].toLowerCase().includes(this.localSearch.toLowerCase()))
    }
  },
  data() {
    return {
      localSearch: ''
    }
  },
  methods: {
    setResult(value) {
      this.localSearch = ''
      this.$emit('result', value)
    },
    checkForResults() {
      if (this.results.length == 0) this.$emit('title', this.localSearch)
    },
    setNewResult() {
      this.$emit('title', this.localSearch)
    }
  }
}
</script>

<style lang="sass" scoped>
.results
  position: absolute
  z-index: 1000
  width: 100%
  border-radius: .85rem

.input-for
  box-shadow: 0px 3px 6px #00000029
  border-radius: 12px
  background-color: #ffffff
  padding: 13px 15px
  border: none
 
</style>
